

const PreviewApp = (props) => {
  const { title, text, icon, img, linkLabel, buttonDeeplinkingLabel, buttonActionLabel, buttonSecondaryLabel, triggerTimelineTemplateId } =
    props.values;
  return (
    <>
      { triggerTimelineTemplateId && triggerTimelineTemplateId !== 'DEFAULT'
          ?
            <div className="dark-background alert">
              <div className="alertBox">
                <i className="nexi-icon-warning"></i>
                <p className="warning">Preview template non disponibile in modalità APP.</p>
                <p className="warning">Selezionare TAB DESKTOP per visionare l'anteprima.</p>
              </div>
            </div>
          :
          <div className="dark-background">
        <div className="app-container">
          <div className={`app-header ${img ? 'with-img' : 'no-img'}`}>
            {img && (
              <img
                className="img"
                src={img}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    'https://via.placeholder.com/1680x750';
                }}
              />
            )}
            {icon &&
              <img
                className="app-icon"
                src={icon}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    'https://via.placeholder.com/100x100';
                }}
              />
            }
          </div>
          <div className="app-content">
            {title && <h2 dangerouslySetInnerHTML={{__html: props.values.title}} className="app-title"></h2>}
            {text && <p dangerouslySetInnerHTML={{__html: text}} className="app-text"></p>}
            {linkLabel && <span className="app-link">{linkLabel}</span>}
          </div>
          <div className="app-actions">
          {props.values.primaryCTAtype === 'DL' ?
              buttonDeeplinkingLabel &&
                <button className="button button--primary">{buttonDeeplinkingLabel}</button>
              :
              buttonActionLabel && (
                <button className="button button--primary">{buttonActionLabel}</button>
              )
            }
            {buttonSecondaryLabel && (
              <button className="anchor app">{props.values.buttonSecondaryLabel}</button>
            )}
          </div>
        </div>
      </div>
      }
    </>
  );
};
export default PreviewApp;
